import { projectImages } from "./images"
import { backendIcon } from "./images"
import { designIcon } from "./images"

const descriptionContent = {
	title: "FullStack Web & React Native Mobile Developer",
	description: "I design and code beautifully simple things, you will love what i create.",
}

const aboutContent = {
	title: "Hi, I’m Mostafa. Nice to meet you.",
	description: `	Since beginning my journey as a freelance Developer nearly 4 years ago, I've done remote
   work for agencies, consulted for startups, and collaborated with talented people to create
   digital products for both business and consumer use. I'm quietly confident, naturally
   curious, and perpetually working on improving my chops one design problem at a time.`,
}

const skills = [
	{
		title: "Front-end Developer",
		icon: designIcon,
		description:
			"I like to code things from scratch, and enjoy bringing ideas to life in the browser.",
		technologies: ["Angular", "React", "JQuery", "Tailwind css"],
	},
	{
		title: "Back-end Developer",
		icon: backendIcon,
		description: "I write clean and structured code.",
		technologies: ["Node.js", "Laravel", "PHP"],
	},
	{
		title: "Mobile Developer",
		icon: designIcon,
		description:
			"I value simple content structure, clean design patterns, and thoughtful interactions.",
		technologies: ["React Native", "Java"],
	},
]

const projects = [
	{
		id: 1,
		name: "Realization of representative site BRAVE SPIRIT",
		images: projectImages[0].images,
		technologies: ["Angular", "MongoDB", "Node.js", "Express", "Bootstrap"],
		client: "Mohamed Nadjmo.",
		createdTime: "feb. 2021",
		duration: "24 hours",
		description: "preventative site for an psychiatrist",
		siteUrl: "https://thebravespirit.org/",
		roles: ["Web Developer", "Designer"],
	},
	{
		id: 2,
		name: "Realization of E-learning Platform BRAVE SPIRIT",
		images: projectImages[1].images,
		technologies: [
			"Angular",
			"MongoDB",
			"Node.js",
			"Express",
			"Sockets.io",
			"Angular material",
			"Bootstrap",
		],
		client: "Mohamed Nadjmo.",
		createdTime: "feb. 2021",
		duration: "3 months",
		description: "E-learning platform for a psychiatrist",
		siteUrl: null,
		roles: ["Web Developer", "Designer"],
	},
	{
		id: 3,
		name: "Tourism Platform - SAFARIATCOM (PFE)",
		images: projectImages[2].images,
		technologies: ["Angular", "Bootstrap"],
		client: "ITEXC Agency",
		createdTime: "june. 2020",
		duration: "15 days",
		description:
			"Platform that is suitable for both travelers, travel agencies, and all other players, an online platform that offers all the necessary services for the tourism sector in Algeria",
		siteUrl: null,
		roles: ["Frontend Developer", "Designer"],
	},
	{
		id: 4,
		name: "Realization of Ecommerce platform BABASHOP",
		images: projectImages[3].images,
		technologies: [
			"Angular",
			"MySql",
			"Laravel",
			"PHP",
			"Angular Material",
			"Bootstrap",
			"Adobe XD",
		],
		client: "Slimani Akram",
		createdTime: "nov. 2019",
		duration: "5 months",
		description: "An ecommerce platform that allows online businesses",
		siteUrl: null,
		roles: ["Web Developer", "Designer"],
	},
	{
		id: 5,
		name: "Url Shortener",
		images: projectImages[4].images,
		technologies: ["React", "Firebase", "Redux"],
		client: "/",
		createdTime: "aug. 2021",
		duration: "1 Week",
		description:
			"React Free URL shortener to create perfect URLs for your business. it helps you create and share branded links with custom domains at scale",
		roles: ["Web Developer"],
		siteUrl: "https://ben-url-shorter.netlify.app/",
	},
	{
		id: 6,
		name: "Realization of covid 19 statistics Mobile application",
		images: projectImages[5].images,
		technologies: ["React Native", "HTML", "CSS", "JS"],
		client: "/",
		createdTime: "feb. 2021",
		duration: "2 days",
		description:
			'React Native Application for digital contact tracing during the COVID - 19 pandemic, i.e. the process of identifying persons ("contacts") who may have been in contact with an infected individual',
		roles: ["Mobile Developer", "Designer"],
		siteUrl: "https://trackcoviddata.netlify.app/",
	},
	{
		id: 7,
		name: "Realization of Workshop Management Platform",
		images: projectImages[6].images,
		technologies: ["Angular", "Node.js", "MongoDB", "Express", "Socket.io", "Angular Material"],
		client: "Roukaia collection",
		createdTime: "nov. 2020",
		duration: "3 months",
		description:
			"server-based workshop management package, which includes all the features required for the end-to-end running of garage or workshop business. with Online Booking module allows for customers to check availability and book products online",
		roles: ["Full Stack Developer", "Designer"],
		siteUrl: null,
	},
	{
		id: 8,
		name: "Realization of Ecommerce platform Full HouseDZ",
		images: projectImages[7].images,
		technologies: ["Angular", "Ngrx", "Angular Material"],
		client: "unknown",
		createdTime: "june. 2021",
		duration: "10 days",
		description: "simple e-commerce website that allows online businesses here in algeria",
		roles: ["Frontend Developer"],
		siteUrl: "https://fullhousedz.com",
	},
]

const educations = []

export { descriptionContent, aboutContent, skills, educations, projects }
